export { Pagination, type IPaginationProps } from './pagination';
